<script setup lang="ts">
import type { DataField, FormData } from './types';
import type { RejectType } from 'vince-core/utils/async';
import { SUPPORTED_SOURCES } from 'vince-core/pages/form-builder/constants';


const { t } = useI18n();
let editReject: RejectType;
let editResolve: ResolveType;
const visible = ref(false);
const formData = ref<FormData>({
    fields: [],
    sourceId: undefined,
    sourceType: null
});

const show = () => {
    return new Promise((resolve, reject) => {
        editReject = reject;
        editResolve = resolve;
        visible.value = true;
    });
};

const done = () => {
    visible.value = false;
    editResolve(formData.value);
};

const cancel = () => {
    visible.value = false;
    editReject();
};

defineExpose({ show });
</script>
<template>
    <VDialog
        v-model:visible="visible"
        :title="t('formBuilder.formDataHeader')"
        class="w-1/4"
        :action-button-label="t('common.actions.ok')"
        @cancel-action="cancel"
        @main-action="done"
    >
        <div>
            <VLFloatLabel class="mt-6">
                <label>{{ t('formBuilder.source') }}</label>
                <VLSelect
                    v-model="formData.sourceType"
                    :options="SUPPORTED_SOURCES.map(it => it.id)"
                    :placeholder="t('formBuilder.source')"
                    :option-label="(v: string) => t(`resourceType.${v.toUpperCase()}`)"
                    fluid
                />
            </VLFloatLabel>
            <component
                :is="SUPPORTED_SOURCES.find(it => it.id === formData.sourceType)!.component"
                v-if="formData.sourceType"
                @update:source-id="(sourceId: string) => formData.sourceId = sourceId"
                @update:fields="(fields: DataField[]) => formData.fields = fields"
            />
        </div>
    </VDialog>
</template>
